import { ReactNode, createContext, useContext, useState } from "react";

interface MetadataHotel {
  numNights: number;
  setNumNights: (numNights: number) => void;
  planId: string;
  setPlanId: (id: string) => void;
  planName: string;
  setPlanName: (name: string) => void;
  points: number;
  setPoints: (points: number) => void;
  monthlyValue: number;
  setMonthlyValue: (value: number) => void;
  description: string;
  setDescription: (description: string) => void;
}

const RoomSelectedContext = createContext<MetadataHotel>({} as MetadataHotel);

type MetadataHotelProps = {
  children: ReactNode;
};

export const MetadataHotelProvider = ({
  children,
}: MetadataHotelProps) => {
  const [numNights, setNumNights] = useState<number>(1);
  const [planName, setPlanName] = useState<string>("");
  const [points, setPoints] = useState<number>(0);
  const [monthlyValue, setMonthlyValue] = useState<number>(0);
  const [description, setDescription] = useState<string>("");
  const [planId, setPlanId] = useState<string>("");

  return (
    <RoomSelectedContext.Provider value={{ 
      numNights,
      setNumNights,
      planId,
      setPlanId,
      planName,
      setPlanName,
      points,
      setPoints,
      monthlyValue,
      setMonthlyValue,
      description,
      setDescription
    }}>
      {children}
    </RoomSelectedContext.Provider>
  );
};

export const useMetadataHotel = () => {
  const context = useContext(RoomSelectedContext);

  if (!context) {
    throw new Error(
      "useMetadataHotel must be used within a MetadataHotelProvider"
    );
  }

  return context;
};
